export default {
  constantContactAuth() {
    window.location =
      `${process.env.AUTH_CONSTANT_CONTACT}&oauthSignup=true&client_id=${process.env.KEY_CONSTANT_CONTACT}&redirect_uri=${process.env.REDIRECT_URI_CONSTANT_CONTACT}`;
  },
  mailChimpAuth() {
    window.location =
      `${process.env.AUTH_MAIL_CHIMP}&client_id=${process.env.KEY_MAIL_CHIMP}&redirect_uri=${process.env.REDIRECT_URI_MAIL_CHIMP}`;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/contacts/actions.js